<template>
    <v-dialog v-model="dialog" max-width="300">
        <v-card>
            <v-card-title class="primary white--text heading">
                Anomaly Machine Learning Models
            </v-card-title>
            <v-card-text>
                Anomaly machine learning models establish normal operation profile using historical data.
                <v-img :src="require('@/assets/img/anomaly_explanation.png')">
                </v-img>
                <span class="caption lighten-1">
                Machine Learning model is data driven and can handle non-linear boundaries and high dimensionality.
                </span>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'AnomalyExplanationDialog',
    data () {
      return {
        dialog: false
      }
    },
    methods: {
      openDialog() {
        this.dialog=true
      }
    }
  }
</script>

<style scoped>

</style>
